import React, { useState, useEffect } from "react";
import { Phone, MessageCircle, Menu, X } from "lucide-react";
import { COMPANY, waLink, telLink } from "../lib/contact";

const NAV = [
  { label: "Início", href: "#inicio" },
  { label: "Sobre", href: "#sobre" },
  { label: "Serviços", href: "#servicos" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Atendimento", href: "#atendimento" },
  { label: "FAQ", href: "#faq" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-all ${
        scrolled
          ? "bg-white border-b-2 border-[#0f172a] shadow-[0_4px_0_#fff505]"
          : "bg-white/95 backdrop-blur border-b-2 border-transparent"
      }`}
    >
      <div className="hazard-bar h-2" />
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#inicio"
            data-testid="header-logo-link"
            className="flex items-center gap-3 flex-shrink-0"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_04c778d5-60fa-4c63-9f95-1580f724c05b/artifacts/yr2zuvns_logo.png"
              alt="PJ Caçambas de Entulho — Aluguel de caçambas em Jundiaí"
              className="h-11 md:h-12 w-auto"
              loading="eager"
            />
            <div className="hidden xl:flex flex-col leading-none whitespace-nowrap pl-1 border-l-2 border-[#0f172a]/10 ml-1">
              <span className="text-[10px] font-extrabold uppercase tracking-[0.2em] text-[#027ec3]">
                Disk Entulho
              </span>
              <span className="text-[10px] font-extrabold uppercase tracking-[0.2em] text-[#0f172a] mt-1">
                Jundiaí · SP
              </span>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-5 xl:gap-7">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                data-testid={`nav-link-${n.label.toLowerCase()}`}
                className="text-[13px] xl:text-sm font-bold uppercase tracking-wide text-[#0f172a] hover:text-[#027ec3] transition-colors relative group whitespace-nowrap"
              >
                {n.label}
                <span className="absolute -bottom-1 left-0 w-0 h-[3px] bg-[#fff505] group-hover:w-full transition-all" />
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 flex-shrink-0">
            <a
              href={telLink}
              data-testid="header-phone-btn"
              className="hidden md:inline-flex items-center gap-2 px-3 py-2 border-2 border-[#0f172a] bg-white text-[#0f172a] font-bold text-sm hover:bg-[#fff505] transition-colors whitespace-nowrap"
            >
              <Phone className="w-4 h-4" strokeWidth={3} />
              <span className="hidden 2xl:inline">{COMPANY.phoneDisplay}</span>
              <span className="2xl:hidden">Ligar</span>
            </a>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="header-whatsapp-btn"
              className="inline-flex items-center gap-2 px-4 py-2 bg-[#25d366] text-white font-bold text-sm border-2 border-[#0f172a] shadow-[3px_3px_0_#0f172a] hover:shadow-[5px_5px_0_#0f172a] hover:-translate-x-[2px] hover:-translate-y-[2px] transition-all uppercase"
            >
              <MessageCircle className="w-4 h-4" strokeWidth={3} />
              WhatsApp
            </a>
            <button
              data-testid="header-mobile-menu-btn"
              className="lg:hidden p-2 border-2 border-[#0f172a] bg-white"
              onClick={() => setOpen(!open)}
              aria-label="Menu"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white border-t-2 border-[#0f172a] px-4 py-4 space-y-2"
        >
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              className="block py-2 px-3 font-bold uppercase text-sm border-l-4 border-[#fff505] text-[#0f172a] hover:bg-[#fff505]/20"
            >
              {n.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
